export default function animateButtons() {
	const buttons = document.querySelectorAll('.btn');

	buttons.forEach(button => {
		let animationStartTime = 0;

		const startAnimation = () => {
			animationStartTime = Date.now();
			button.classList.remove('btn-animating-exit');
			button.classList.add('btn-animating-enter');
		};

		const endAnimation = () => {
			const durationValue = getComputedStyle(button)
				.getPropertyValue('--enter-duration')
				.trim();
			const enterDuration = durationValue.endsWith('ms')
				? parseFloat(durationValue)
				: parseFloat(durationValue) * 1000;

			const animationDuration = Date.now() - animationStartTime;

			if (animationDuration >= enterDuration || !button.classList.contains('btn-animating-enter')) {
				button.classList.remove('btn-animating-enter');
				button.classList.add('btn-animating-exit');
			} else {
				const remainingTime = enterDuration - animationDuration;
				setTimeout(() => {
					button.classList.remove('btn-animating-enter');
					button.classList.add('btn-animating-exit');
				}, remainingTime);
			}
		};

		// Mouse events
		button.addEventListener('mouseenter', startAnimation);
		button.addEventListener('mouseleave', endAnimation);

		// Focus events
		button.addEventListener('focusin', startAnimation);
		button.addEventListener('focusout', endAnimation);
	});
}
